import { render, staticRenderFns } from "./CaseSeaWaveInformation.vue?vue&type=template&id=654fa8a6"
import script from "./CaseSeaWaveInformation.vue?vue&type=script&lang=js"
export * from "./CaseSeaWaveInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports